import { Inject, Injectable } from '@angular/core';
import saveAs from 'file-saver';
import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs';
import { EventNameAnalytics } from '../../helpers/event-name-analytics';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { LoopBackAuth } from "../../shared/sdk";
import { FileDownloaderProvider } from './../../providers/file-downloader/file-downloader';
import { EmployeeRequestReportApi } from './../../shared/nestjs/gd-only/services/employee-request-report.api';
import { NestApiProvider } from './../../shared/nestjs/nest-api';
import { ViewEmpReqApi } from './../../shared/sdk/services/custom/ViewEmpReq';
@Injectable()
export class EmployeeRequestReportBloc {
    constructor(
        @Inject(LoopBackAuth) protected auth: LoopBackAuth,
        private employeeRequestReportApi: EmployeeRequestReportApi,
        private platform: Platform,
        private fileDownloaderProvider: FileDownloaderProvider,
        private viewEmpReqApi: ViewEmpReqApi,
        private nestApiProvider: NestApiProvider,
        private analyticsProvider: AnalyticsProvider
    ) { }

    generateExcel(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadExcelBlob(data, 'Employee Request Report')
        } else {
            saveAs(data, 'Employee Request Report.xlsx')
        }
    }

    downloadExcel(data): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
        return this.employeeRequestReportApi.downloadExcel(data);
    }

    downloadExcelLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            
        })
    }

    generatePdf(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadPdfBlob(data, 'Employee Request Report')
        } else {
            saveAs(data, 'Employee Request Report.pdf')
        }
    }

    downloadPdf(data): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
        return this.employeeRequestReportApi.downloadPdf(data);
    }

    downloadPdfLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            
        })
    }

    sendExcel(data): Observable<any> {
        let dataExcel = {};
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                    return this.employeeRequestReportApi.reportSendEmailExcel(data)
                } else {
                    dataExcel = {
                        fullName: data.fullName,
                        emailUser: data.email,
                        sendEmail: true,
                        status: { 'inq': data.status },
                        reqDate:{ 'gte': data.startDate, 'lte': data.addOneDay},
                        reqtype:{ 'inq': data.reqType},
                        empId: { 'inq': data.listEmp },
                    }
                    return this.viewEmpReqApi.download(dataExcel);
                }
            })
    }

    sendPdf(data): Observable<any> {
        let dataPdf={};
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                    return this.employeeRequestReportApi.reportSendEmailPdf(data)
                } else {
                    dataPdf = {
                        fullName: data.fullName,
                        emailUser: data.email,
                        sendEmail: true,
                        status: { 'inq': data.status },
                        reqDate:{ 'gte': data.startDate, 'lte': data.addOneDay},
                        reqtype:{ 'inq': data.reqType},
                        empId: { 'inq': data.listEmp },
                    }
                    return this.viewEmpReqApi.pdfmake(dataPdf)
                }
            })
    }

    previewLB(data): Observable<any> {
        return this.viewEmpReqApi.previewReport(data);
    }
}


// WEBPACK FOOTER //
// ./src/bloc/report/employee-request-report.bloc.ts